module.exports = __webpack_public_path__ + "4ff43873b11b9cab2d677cc31997fd76.png";